function initializeEntriesPopovers() {
  const entriesBanners = document.querySelectorAll('[data-entries-info]');
  console.log('Entries banner elements:', entriesBanners);

  if (!entriesBanners.length) return;

  entriesBanners.forEach((banner) => {
    // Prevent double-binding
    if (banner.dataset.popoverInitialized) return;
    banner.dataset.popoverInitialized = 'true';

    const popover = banner.querySelector('.alert-popover');
    const closeButton = popover.querySelector('.entries-popover-close');

    banner.addEventListener('click', (e) => {
      const isClickInsidePopover = popover.contains(e.target);
      console.log('Is click inside popover:', isClickInsidePopover);

      if (!isClickInsidePopover) {
        e.preventDefault();
        e.stopPropagation();
        togglePopover(popover);
      }
    });

    closeButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      hidePopover(popover);
    });

    document.addEventListener('click', (e) => {
      const isClickInsideBanner = banner.contains(e.target);
      console.log('Is click inside entries banner:', isClickInsideBanner);

      if (!isClickInsideBanner) {
        hidePopover(popover);
      }
    });
  });

  function togglePopover(popover) {
    const currentDisplay = window.getComputedStyle(popover).display;
    if (currentDisplay === 'none') {
      showPopover(popover);
    } else {
      hidePopover(popover);
    }
  }

  function showPopover(popover) {
    popover.style.display = 'block';
    popover.style.opacity = '1';
  }

  function hidePopover(popover) {
    popover.style.display = 'none';
    popover.style.opacity = '0';
  }
}

// Run once after DOM loads, then again after 1 second
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initializeEntriesPopovers();
    setTimeout(initializeEntriesPopovers, 1000);
  });
} else {
  initializeEntriesPopovers();
  setTimeout(initializeEntriesPopovers, 1000);
}
